<!-- In travel order. An access leg (see `isLineHaul`) is shown muted: it feeds
     the journey, is left out of the emissions and never becomes a transport
     when the tip is applied. A road itinerary has no legs. -->
@if (route().legs.length) {
  <ol class="flex flex-col gap-2">
    @for (leg of route().legs; track $index) {
      <li class="grid grid-cols-[20px_minmax(0,1fr)] gap-2.5">
        <span
          class="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full"
          [class]="
            leg.isLineHaul
              ? 'bg-primary-100 text-primary-600'
              : 'border border-dashed border-primary-300 text-greyscale-600'
          "
        >
          <lucide-icon [name]="vehicleIcon(leg.transportType)" [size]="11" />
        </span>
        <span class="min-w-0 text-paragraph-xs-reg text-greyscale-700">
          <span
            class="block"
            [class]="
              leg.isLineHaul
                ? 'font-semibold text-primary-900'
                : 'font-medium text-greyscale-600'
            "
          >
            @if (!leg.isLineHaul) {
              {{ "reductionTips.route.access" | transloco }}
            }
            {{ leg.departureStop }} → {{ leg.arrivalStop }}
          </span>
          {{ legDetails(leg) }}
        </span>
      </li>
    }
  </ol>
}

<div class="flex flex-wrap items-center gap-x-4 gap-y-1 text-paragraph-xs-reg">
  <a
    [href]="route().mapsUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="flex items-center gap-1 font-medium text-primary-600 hover:underline"
  >
    <lucide-icon name="map" [size]="12" />
    {{ "reductionTips.route.openInMaps" | transloco }}
  </a>
  @for (operator of operators(); track operator.url) {
    <a
      [href]="operator.url"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center gap-1 text-primary-600 hover:underline"
    >
      <lucide-icon name="external-link" [size]="12" />
      {{ operator.name }}
    </a>
  }
  <ng-content />
</div>
